import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import './i18n';
import { initTheme } from './lib/theme';

// Resolves and applies the persisted (or system) theme synchronously, before
// the first paint, to avoid a flash of the wrong theme.
initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
